import DesktopMenu from './menu/DesktopMenu'
import MobileMenu from './menu/MobileMenu'

class Menu {
    private root: HTMLElement;
    private currentType: 'desktop' | 'mobile';
    private currentMenu: DesktopMenu | MobileMenu | null = null;

    constructor() {
        this.root = document.querySelector('.header-bottom-row') as HTMLElement
        this.currentType = innerWidth > 1200 ? 'desktop' : 'mobile'
    }

    public init = async () => {
        this.currentType === 'desktop' ? await this.handleDesktop() : await this.handleMobile()
        this.watcher()
    }

    private watcher = () => {
        const mediaQuery = window.matchMedia('(min-width: 1200px)')
        mediaQuery.addEventListener('change', async (e) => {
            await this.currentMenu?.destroy()
            this.root.replaceWith(this.root.cloneNode(true))
            this.root = document.querySelector('.header-bottom-row') as HTMLElement
            e.matches ? await this.handleDesktop() : await this.handleMobile()
        })
    }

    private handleDesktop = async () => {
        this.currentType = 'desktop'
        const menu = new DesktopMenu(this.root.querySelector<HTMLElement>("#default-navigation") as HTMLElement)
        this.currentMenu = menu;
        await menu.init()
    }

    private handleMobile = async () => {
        this.currentType = 'mobile'
        const menu = new MobileMenu(this.root.querySelector<HTMLElement>("#default-navigation") as HTMLElement)
        this.currentMenu = menu;
        await menu.init()
    }
}

export default Menu